import { useEffect, useState } from 'react';

/** Keep short preparation pauses silent and reserve space outside the picture. */
export function PreviewStatus({ ready }: { ready: boolean }) {
  const [waiting, setWaiting] = useState(false);
  useEffect(() => {
    setWaiting(false);
    if (ready) return;
    const timer = setTimeout(() => setWaiting(true), 1000);
    return () => clearTimeout(timer);
  }, [ready]);
  return <div className="preview-readiness" aria-live="off">{!ready && waiting ? 'Updating preview…' : '\u00a0'}</div>;
}
